module.exports = __webpack_public_path__ + "img/fiji-2017-1.e0f30d06.jpg";